import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library, findIconDefinition, IconName } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

function renderCategoryIcon(imagePath: string, label: string) {
	if (!imagePath) return null;

	// SVG inline content
	if (imagePath.trimStart().startsWith("<svg")) {
		return <span dangerouslySetInnerHTML={{ __html: imagePath }} />;
	}

	// Font Awesome icon name: camelCase (e.g. "faHeadSideMask") or kebab-case (e.g. "head-side-mask")
	const kebab = imagePath
		.replace(/^fa/, "")
		.replace(/([A-Z])/g, (m) => `-${m.toLowerCase()}`)
		.replace(/^-/, "")
		.toLowerCase() as IconName;

	const iconDef = findIconDefinition({ prefix: "fas", iconName: kebab });
	if (iconDef) {
		return <FontAwesomeIcon icon={iconDef} />;
	}

	// Fall back to treating it as an image URL/path
	return <img src={imagePath} alt={label} />;
}

export const CategoryStep: React.FC<{
	categories: { id: string; label: string; imagePath?: string }[];
	onSelect: (categoryId: string) => void;
	selectedCategory?: string;
}> = ({ categories, onSelect, selectedCategory }) => {
	const getBodyPartIcon = (id: string) => {
		const icons: Record<string, string> = {
			eyes: "👁️",
			respiratory: "🫁",
			abdominal: "🫃",
			urinary: "💧",
			skin: "👤",
		};
		return icons[id] || "📍";
	};

	return (
		<div className="body-parts-grid">
			{categories.map((category) => {
				const isSelected = selectedCategory === category.id;
				return (
					<button
						key={category.id}
						className={`body-part-card ${isSelected ? "selected" : ""}`}
						onClick={() => onSelect(category.id)}
					>
						<div className="body-part-icon">
							{category.imagePath
								? renderCategoryIcon(category.imagePath, category.label)
								: getBodyPartIcon(category.id)}
						</div>
						<div className="body-part-label">{category.label}</div>
						{isSelected && <div className="checkmark">✓</div>}
					</button>
				);
			})}
		</div>
	);
};
